export const ZENDESK_KEYS = {
  fr: 'f5d5db0d-c83c-41b5-ba20-ab8e9e267ae4',
  es: '9b02de52-dc0a-455d-b821-fa4e88afc8d2',
  it: '497b917f-d259-4f04-b309-6c2e8d73f82f',
  de: 'f4bc3933-f306-4248-ad3b-0461d92854b1',
  __sandbox__: '2afdfea0-17eb-44c0-af49-6deeb3fba54b'
};